export default "__VITE_ASSET__a5033ee3__"